import React from 'react';

export default function List() {
	return (
		<svg
			className="svg list"
			height="21"
			viewBox="0 0 20 20"
			width="20"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g>
				<path d="m7 1h13v2h-13z" />
				<circle
					cx="2"
					cy="2"
					r="2"
				/>
				<path d="m7 9h13v2h-13z" />
				<circle
					cx="2"
					cy="10"
					r="2"
				/>
				<path d="m7 17h13v2h-13z" />
				<circle
					cx="2"
					cy="18"
					r="2"
				/>
			</g>
		</svg>
	);
}
